(() => {
  const story = document.querySelector('[data-jaga-story]');
  if (!story || story.dataset.jagaReady) return;
  story.dataset.jagaReady = 'true';
  const dialog = story.querySelector('[data-jaga-lightbox]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const links = Array.from(story.querySelectorAll('[data-jaga-photo]'));
  const photo = dialog.querySelector('[data-jaga-full]');
  const caption = dialog.querySelector('[data-jaga-full-caption]');
  const count = dialog.querySelector('[data-jaga-count]');
  let current = 0;
  const show = (index) => {
    current = (index + links.length) % links.length;
    const thumbnail = links[current].querySelector('img');
    photo.width = Number(thumbnail.getAttribute('width')) || 1320;
    photo.height = Number(thumbnail.getAttribute('height')) || 1730;
    photo.src = links[current].href;
    photo.alt = links[current].dataset.caption;
    caption.textContent = links[current].dataset.caption;
    count.textContent = `${current + 1} / ${links.length}`;
  };
  links.forEach((link, index) => link.addEventListener('click', (event) => {
    event.preventDefault();
    show(index);
    dialog.showModal();
    document.documentElement.classList.add('pms-jaga-open');
  }));
  dialog.querySelector('[data-jaga-close]').addEventListener('click', () => dialog.close());
  dialog.querySelector('[data-jaga-prev]').addEventListener('click', () => show(current - 1));
  dialog.querySelector('[data-jaga-next]').addEventListener('click', () => show(current + 1));
  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      show(current + (event.key === 'ArrowRight' ? 1 : -1));
    }
  });
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    }
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('pms-jaga-open');
    links[current].focus();
  });
})();
